/**
 * Enter/leave hooks for the "New pledge" supporter card swap: the old card
 * lifts up and fades to reveal the deck behind it while the new card rises
 * into place. Use on a `<Transition :css="false">` keyed on pledge identity.
 */
export const usePledgeCardSwap = () => {
  const { $anime } = useNuxtApp()
  const reducedMotion = usePreferredReducedMotion()

  const onEnter = (el: Element, complete: () => void) => {
    if (reducedMotion.value === 'reduce') return complete()

    $anime({
      targets: el,
      translateY: [10, 0],
      scale: [0.96, 1],
      opacity: [0, 1],
      duration: 400,
      delay: 100,
      easing: slideEasing,
      complete,
    })
  }

  const onLeave = (el: Element, complete: () => void) => {
    if (reducedMotion.value === 'reduce') return complete()

    // Take the old card out of flow so the new card holds the layout, and
    // keep it on top while it lifts away.
    const root = el as HTMLElement
    root.style.position = 'absolute'
    root.style.top = '0'
    root.style.left = '0'
    root.style.right = '0'
    root.style.zIndex = '10'

    $anime({
      targets: root,
      translateY: -28,
      opacity: 0,
      duration: 450,
      easing: slideEasing,
      complete,
    })
  }

  return { onEnter, onLeave }
}
